import React, { useState, Component } from 'react';
import styled from "styled-components";
import arrow from "../../../../assets/imgs/icons/load-more-arrow.svg"

class GetAuthenticators extends Component {
    constructor(props) {
      super(props)
      this.state = {
        // showError : true,
      }

    this.idPrefix = Date.now();
    

   this.Data = this.props.liabilitiesGetAuthenticators;

  //this.Data = liabilitiesGetAuthenticators;//comment this

    this.sendData = {
      AdditionalValidationDetails:'',
      Authenticators:''
    }
  //*****************************AdditionalValidationDetails****************** */
      this.sendAdditionalValidationDetails = []
      if(this.Data.AdditionalValidationDetails != "NA"){
      this.Data.AdditionalValidationDetails.forEach(()=>{
        this.sendAdditionalValidationDetails.push({
          ParameterName : " ",
          Value: ""
        });
      })}else{
        this.sendAdditionalValidationDetails = "NA"
      }
  //******************************Authenticators*********************** */
      this.sendAuthenticators = []
      this.Data.Authenticators.forEach(()=>{
        this.sendAuthenticators.push({
          ParameterName : " ",
          Value: ""
        });
      })      
  }

//AdditionalValidationDetails
  handleInputFields1 = (event, ParameterName,index) => {

    this.sendAdditionalValidationDetails[index].ParameterName = ParameterName;
    this.sendAdditionalValidationDetails[index].Value = event.target.value;
    //console.log(sendAdditionalValidationDetails)
  }

  //Authenticators
  handleInputFields2 = (event, ParameterName,index) => {

      this.sendAuthenticators[index].ParameterName = ParameterName;
      this.sendAuthenticators[index].Value = event.target.value;
      //console.log(sendAuthenticators)

  }

  // handleCancelClick = () => {
  //   let inputString =  "Cancel" + "<split>" + "Cancel"
  //   window['autosubmit'](inputString);

  //   document.getElementById("formDisable").style.pointerEvents = "none"

  // }

  handleSubmitEnter = (e) => {

    let isReadytoSendData1 = true;
    let isReadytoSendData2 = true;


  if (e.keyCode === 13 || e == "click") {


  document.querySelectorAll("input").forEach(item => {item.blur()})
  document.querySelectorAll("select").forEach(item => {item.blur()})
  
//AdditionalValidationDetails
    if(this.Data.AdditionalValidationDetails!="NA"){
    this.sendAdditionalValidationDetails.map((item,i)=>{
      if(item.Value.match(this.Data.AdditionalValidationDetails[i].Regex)){
     //   console.log(item.ParameterName,"satisfied");
     
        // document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.AdditionalValidationDetails[i].ParameterName).innerHTML = "";
        document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.AdditionalValidationDetails[i].ParameterName).style.color = "#666";
      }else{
       // console.log(item.ParameterName, this.Data.AdditionalValidationDetails[i].ErrorMessage)
        // document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.AdditionalValidationDetails[i].ParameterName).innerHTML =  this.Data.AdditionalValidationDetails[i].ErrorMessage;
        document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.AdditionalValidationDetails[i].ParameterName).style.color = "red";
        isReadytoSendData1 = false;
      }
    })}
     //Authenticators
    this.sendAuthenticators.map((item,i)=>{
      if(item.Value.match( this.Data.Authenticators[i].Regex)){
      //  console.log(item.ParameterName,"satisfied");
        //document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.Authenticators[i].ParameterName).innerHTML = "";
        document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.Authenticators[i].ParameterName).style.color = "#666";
      }else{
       // console.log(item.ParameterName, Data.Authenticators[i].ErrorMessage)
        // document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.Authenticators[i].ParameterName).innerHTML =  this.Data.Authenticators[i].ErrorMessage;
        document.getElementById(this.idPrefix + "inputBox_Error" +  this.Data.Authenticators[i].ParameterName).style.color = "red";
        isReadytoSendData2 = false;
      }
    })

    if(isReadytoSendData1 == true && isReadytoSendData2 == true){

      this.sendData.AdditionalValidationDetails = this.sendAdditionalValidationDetails;
      this.sendData.Authenticators= this.sendAuthenticators;
     // console.log("sendData: ",this.sendData);

      let inputString =  "Confirm" + "<split>" + JSON.stringify(this.sendData)
      window['autosubmit'](inputString);

     // console.log("to backend: ",JSON.stringify(this.sendData));
      document.getElementById("formDisable").style.pointerEvents = "none"
     

    }
   }
  }
 

render() {
      
  return(
    <FormBlock id="formDisable"  onKeyDown={(e) => this.handleSubmitEnter(e)}>
      {/* AdditionalValidationDetails */}
      { this.Data.AdditionalValidationDetails != "NA"?
         this.Data.AdditionalValidationDetails.map((item,i)=>{
          if(item.DataType == "List"){
          return(
            <div className="input-block" key={i}>
                <label className= "title-label">{item.ParameterName}</label><br></br>
                <select className="user-select" name="RechargeType" 
                      onChange={()=>this.handleInputFields1(event,item.ParameterName,i)} 
                >  
                 <option value="" >Select your option</option>
                  {item.ListName.map((subItem,k)=>{
                  return(
                    <option key={k} value={item.ListValue[k]}>{subItem}</option>
                  )
                  })}
                </select> 
                <div className="errorBlock" id={this.idPrefix + "inputBox_Error" + item.ParameterName }>{item.ErrorMessage}</div> 
            </div>
          )
        }else{
        return(
          <div className="input-block" key={i} >
            <label className= "title-label">{item.ParameterName}</label><br></br>
            <input className= "user-input" pattern={item.Regex} 
                  onChange={()=>this.handleInputFields1(event,item.ParameterName,i)} 
               
            ></input>
            <div className="errorBlock" id={this.idPrefix + "inputBox_Error" + item.ParameterName }>{item.ErrorMessage}</div> 
          </div>
        )}})           
      :null
      }

       {/* Authenticators    */}
      { this.Data.Authenticators != "NA"?
         this.Data.Authenticators.map((item,i)=>{
          if(item.DataType == "List"){
            return(
              <div className="input-block" key={i}>
                <label className= "title-label">{item.ParameterName}</label><br></br>
                <select className="user-select" name="RechargeType" 
                   onChange={()=>this.handleInputFields2(event,item.ParameterName,i)}
                  
                > 
                 <option value="" >Select your option</option>
                  {item.ListName.map((subItem,k)=>{
                  return(
                    <option key={k} value={item.ListValue[k]}>{subItem}</option>
                  )
                  })}    
                </select> 
             <div className="errorBlock" id={this.idPrefix + "inputBox_Error" + item.ParameterName }>{item.ErrorMessage}</div> 
              </div>
            )
          }else{
            return(
              <div className="input-block" key={i} >
                <label className= "title-label">{item.ParameterName}</label><br></br>
                <input className= "user-input" pattern={item.Regex} 
                      onChange={()=>this.handleInputFields2(event,item.ParameterName,i)} 
                    
                ></input>
             <div className="errorBlock" id={this.idPrefix + "inputBox_Error" + item.ParameterName }>{item.ErrorMessage}</div> 
              </div>
            )
          }
        })
      :null
      }



      <ActionButton className="action-elem"
        onClick={(e)=>this.handleSubmitEnter("click")} >Confirm</ActionButton>
  
      {/* <div className="action-elem" style={{width: "100%"}}
        onClick={()=>this.handleCancelClick()}>Cancel</div> */}
      <div className="action-elem" style={{display:"none"}}></div> 

      </FormBlock>
    ) 
  }
}

const FormBlock=styled.div`

  //background: pink;
  width: 100%;
  min-width: 280px;
  height: auto;
  margin: 15px 0;

  & .input-block{
      //background: yellow;
      margin-bottom:16px;
  }
  & .title-label{
      padding-left: 4px;
      color: #000
      font-size: 13px;
  }
  & .user-select{
      background-color: #fff;
      border: 1px solid #ccc;
    //  box-shadow: 0px 5px 12px rgba(0,0,0,0.1);
      border-radius: 5px;
      height: 44px;
      width: 100%;
      color: #CCC;
      padding-left: 10px;
      font-size:14px;
      color: #666666;
      margin-top: 4px;
  }
  & .user-input{
      background-color: #fff;
      border: 1px solid #ccc;
     // box-shadow: 0px 5px 12px rgba(0,0,0,0.1);
      border-radius: 5px;
      height: 44px;
      width: 100%;
      color: #CCC;
      padding-left: 15px;
      font-size:14px;
      color: #666666;
      margin-top: 4px;
  }

  select {
    background: url(${arrow}) no-repeat right;
    -webkit-appearance: none;
     background-position-x: 95%;

}

.errorBlock{
  font-size: 12px;
  padding-left: 5px;
  margin-top:5px;

}

`
const ErrorBlock = styled.div`
`

const ActionButton = styled.div`
  width: 32%;
  margin: 0 auto;
  border: 0px solid #2c387a;
  background: #2c387a;
  color: #fff;

  
`

export default GetAuthenticators;